
import React from 'react'

import PropTypes from 'prop-types'

import { Container, ImageStyled, ContentContainer } from './styles'

const ImageBackground = (props) => {
  const {
    src,
    style,
    minHeight,
    size,
    containerStyle,
    children,
    ...rest
  } = props

  return (
    <Container style={ containerStyle }>
      <ImageStyled
        { ...rest }
        style={ {
          ...style,
          minHeight,
          backgroundSize: size,
          backgroundImage: `url("${ src }")`
        } }
      >
        <ContentContainer>
          {children}
        </ContentContainer>
      </ImageStyled>
    </Container>
  )
}

ImageBackground.propTypes = {
  src: PropTypes.string.isRequired,
  containerStyle: PropTypes.object,
  style: PropTypes.object,
  minHeight: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  size: PropTypes.oneOf(['cover', 'contain']),
  children: PropTypes.any
}

ImageBackground.defaultProps = {
  containerStyle: {},
  style: {},
  minHeight: 100,
  size: 'contain',
  children: null
}

export default ImageBackground
